import { AppItem } from "@app/types";
import { AddItemRequest, ApiDuplicate, ApiGetItemResponse } from "./types";
import { createApiAction } from "./utils";

export const apiGetItems = () =>
  createApiAction(async (dispatch) => {
    const resp = await dispatch<ApiGetItemResponse[]>({
      path: "/api/items",
      method: "GET",
    });
    return resp.map<AppItem>((item) => ({
      id: item.id,
      name: item.name,
      tags: item.tags,
      addedAt: new Date(item.addedAt.date),
      rating: item.rating,
      link: item.link,
    }));
  });

export const apiPostItems = (data: AddItemRequest) =>
  createApiAction((dispatch) =>
    dispatch<ApiGetItemResponse>({
      path: "/api/items",
      method: "POST",
      body: JSON.stringify(data),
    }).then(
      (item): AppItem => ({
        id: item.id,
        name: item.name,
        tags: item.tags,
        addedAt: new Date(item.addedAt.date),
        rating: item.rating,
        link: item.link,
      })
    )
  );

export const apiPutItemsId = (id: string, data: AddItemRequest) =>
  createApiAction<void>((dispatch) =>
    dispatch({
      path: `/api/items/${id}`,
      method: "PUT",
      body: JSON.stringify(data),
    })
  );

export const apiDeleteItemsId = (id: string) =>
  createApiAction<void>((dispatch) =>
    dispatch({
      path: `/api/items/${id}`,
      method: "DELETE",
    })
  );

export const apiGetAuth = () =>
  createApiAction<{ authenticated: boolean }>((dispatch) =>
    dispatch({
      path: "/api/auth",
      method: "GET",
    })
  );

export const apiPostAuth = (data: { user: string; password: string }) =>
  createApiAction<{ authenticated: boolean }>((dispatch) =>
    dispatch({
      path: "/api/auth",
      method: "POST",
      body: JSON.stringify(data),
    })
  );

/**
 * Names already stored that resemble `name`.
 *
 * The scoring is the server's: it canonicalises both sides — case, accents, punctuation
 * — and only answers with what clears its confidence threshold, so the client has
 * nothing to decide and the two cannot drift apart.
 */
export const apiGetDuplicates = (name: string) =>
  createApiAction<ApiDuplicate[]>((dispatch) =>
    dispatch({
      path: `/api/duplicates?name=${encodeURIComponent(name)}`,
      method: "GET",
    })
  );
